import { Component} from '@angular/core';
import { NavController, NavParams,Events,ViewController,ToastController,LoadingController} from 'ionic-angular';
import {ApplicationVariables} from '../../providers/config';
import { Storage } from '@ionic/storage';
import { ApiOffline } from '../../providers/api-offline';
import { MsgManager } from '../../providers/msg-manager';
import {GVLogger} from "../../services/gv-logger";


@Component({
  selector: 'page-internet-check-popup',
  templateUrl: 'internet-check-popup.html',
})
export class InternetCheckPopupPage {

  constructor(public navCtrl: NavController,
  	public navParams: NavParams,
  	private storage:Storage,
  	private events:Events,
  	private viewCtrl:ViewController,
  	private apiOffline:ApiOffline,
  	private toastCtrl:ToastController,
    private loadCtrl:LoadingController,
    private msgManager:MsgManager,
    private gVLogger: GVLogger) {
  }

  ionViewDidLoad() {
    this.gVLogger.log('ionViewDidLoad InternetCheckPopupPage');
  }

  offlieMode(){
  		this.apiOffline.checkDataAvailablie().then(res=>{ // if got data

          ApplicationVariables.isOffline = true;
          this.storage.set("isOfflineMode",true).then(()=>{
            this.events.publish("ModeChanged");
            this.viewCtrl.dismiss();
            this.events.publish("gotoSearchCustomersPage");

            // .then(()=>{
            //   setTimeout(()=>{
      	  	  //   this.navCtrl.setRoot(HomePage);
            //   },1000);
            // });
            //.then(()=>{
            //this.navCtrl.setRoot(SearchCustomersPage);
            // });
            // .then(()=>{
      	  	// 	this.viewCtrl.dismiss();
      	  	// });
           });

        },
        rej=>{
          this.msgManager.toastMsg("Sorry no offline data available");
          let t =  this.toastCtrl.create({
           message:"Sorry no offline data available",
           duration:3000,
           position: 'bottom'
           });
         t.present();

        });

  }

  retry(){

  	let load = this.loadCtrl.create({
                        content:"Retrying..."
                      });
  	load.present();

  	setTimeout(()=>{
  		load.dismiss();
  	},2000);


  }


}



// WEBPACK FOOTER //
// ./src/pages/internet-check-popup/internet-check-popup.ts